import fetchWithAuth from "../middlewares/fetchWithAuth";
import { API_BASE_URL } from "../config";

const API_URL = `${API_BASE_URL}/clubes`;

// Función para obtener las competiciones
export const getClubesByNombre = async (letrasNombre, navigate) => {
  try {
    const response = await fetchWithAuth(
      `${API_URL}/nombre/${encodeURIComponent(letrasNombre)}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      navigate
    );

    if (response.ok) {
      const data = await response.json();
      return data;
    }

    throw new Error("Error al obtener los clubes");
  } catch (error) {
    throw error;
  }
};

export const getEquiposByIdClubAndIdTemporada = async (
  idClub,
  idTemporada,
  navigate
) => {
  try {
    const response = await fetchWithAuth(
      `${API_URL}/equipos/${idTemporada}/${idClub}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      navigate
    );

    if (response.ok) {
      const data = await response.json();
      return data;
    }

    throw new Error("Error al obtener los equipos del club");
  } catch (error) {
    throw error;
  }
};
